import * as React from "react";
const SvgChevronLeftIcon = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M8 12L14 18L15.41 16.59L10.83 12L15.41 7.41L14 6L8 12Z", fill: "currentColor" }));
export default SvgChevronLeftIcon;
